import { render, staticRenderFns } from "./activeReport.vue?vue&type=template&id=8ffca9cc&scoped=true"
import script from "./activeReport.vue?vue&type=script&lang=js"
export * from "./activeReport.vue?vue&type=script&lang=js"
import style0 from "./activeReport.vue?vue&type=style&index=0&id=8ffca9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffca9cc",
  null
  
)

export default component.exports